import {
  ChangeDetectorRef,
  Component,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { AppService } from 'src/app/app.service';
import { HttpService } from '../../services/http.service';
import { Subject, take, takeUntil } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-additional-charges',
  standalone: false,
  templateUrl: './additional-charges.component.html',
  styleUrl: './additional-charges.component.scss',
})
export class AdditionalChargesComponent implements OnChanges, OnDestroy {
  chargesList: any = [];
  mauntList: any = [];
  chargesColumn = ['charge', 'rate', 'delete'];
  mountColumn = ['country', 'rate', 'delete'];
  countryListArr: any;
  userData: any;
  @Input() rateId: number = 0;
  @Input() orderId: number = 0;
  @Input() operation: string = 'add';
  @Input() changeDetect: any;
  private mautSubscription: any;
  private chargeSubscription: any;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private appService: AppService,
    private httpService: HttpService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    this.countryListArr = this.appService.countryListArr
      ?.filter((i: any) => i.ISMaut)
      .sort((a: any, b: any) =>
        a.CountryName.toLowerCase() > b.CountryName.toLowerCase() ? 1 : -1
      );
    this.chargeSubscription = this.appService.additionalCostEmit
      .pipe(takeUntil(this.destroy$))
      .subscribe((evt: any) => {
        this.chargesList = [];
        this.chargesList = [...evt];
        this.cdr.detectChanges();
        // this.chargesList.forEach((obj:any) => {
        //   obj.charge = this.appService.deResingDoubleQuotess(obj?.charge);

        // });
        // this.chargeSubscription.unsubscribe();
      });
    this.mautSubscription = this.appService.mautCostEmit
      .pipe(takeUntil(this.destroy$))
      .subscribe((evt: any) => {
        if (evt.length === 1 && evt[0]?.country === '') {
          this.mauntList = [];
          return;
        }
        this.getCountryList(evt);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['rateId']?.currentValue ||
      changes['rateId']?.currentValue === 0
    ) {
    } else {
      this.rateId = changes['rateId']?.currentValue;
    }

    if (changes['orderId']?.currentValue) {
      this.orderId = changes['orderId'].currentValue;
    }
    if (changes['operation']?.currentValue) {
      this.operation = changes['operation'].currentValue;
    }
    if (changes['changeDetect']?.currentValue) {
      this.chargesList = [...this.chargesList];
      this.mauntList = [...this.mauntList];
    }
    // this.ngZone.run(() =>{
    //   this.chargesList = new MatTableDataSource([...this.chargesList])
    //  this.mauntList = new MatTableDataSource([...this.mauntList])
    // })
    this.countryListArr = this.appService.countryListArr
      ?.filter((i: any) => i.ISMaut)
      .sort((a: any, b: any) =>
        a.CountryName.toLowerCase() > b.CountryName.toLowerCase() ? 1 : -1
      );
  }

  formatElementData(val: any) {
    return '' + Number(val).toFixed(2);
  }
  formatMautData(val: any) {
    return '' + Number(val).toFixed(3);
  }

  onAddCostItem(screen: string) {
    this.appService.onRAvalueChanged = true;
    if (screen === 'charge') {
      this.chargesList.push({ charge: '', rate: 0 });
      this.chargesList = [...this.chargesList];
    } else {
      this.mauntList.push({ country: 0, rate: 0 });
      this.mauntList = [...this.mauntList];
    }
    console.log(
      'this...',
      this.appService.rateDateSource[this.appService.selectedItem]
    );
    let obj = this.appService.rateDateSource[this.appService.selectedItem];
    obj.DataSourceForFuelPrice = obj.DataSourceForFuelPrice
      ? this.appService.escapeSingleQuotes(obj.DataSourceForFuelPrice)
      : '';
    obj.FuelEscalatorVersion = obj.FuelEscalatorVersion
      ? this.appService.escapeSingleQuotes(obj.FuelEscalatorVersion)
      : '';
    obj.FuelEscalatorComment = obj.FuelEscalatorComment
      ? this.appService.escapeSingleQuotes(obj.FuelEscalatorComment)
      : '';
    obj.Remarks = obj.Remarks
      ? this.appService.escapeSingleQuotes(obj.Remarks)
      : '';
    this.appService.rateDateSource[this.appService.selectedItem] = [...obj];
  }

  onExportData() {}

  onMautDelete(index: number) {
    this.appService.onRAvalueChanged = true;
    this.mauntList.splice(index, 1);
    this.mauntList = [...this.mauntList];
    this.onMautSave();
  }

  onChargeDelete(index: number) {
    this.appService.onRAvalueChanged = true;
    this.chargesList.splice(index, 1);
    this.chargesList = [...this.chargesList];
    this.onAdditonalSave();
  }

  onMautSave() {
    let obj = this.appService.rateDateSource[this.appService.selectedItem];
    if (obj.RateTableTypeID === 42) {
      this.appService.rateDateSource[this.appService.selectedItem].MautCost =
        this.mauntList.map((obj: any) => obj.rate).join(',');
      this.appService.rateDateSource[this.appService.selectedItem].CountryID =
        this.mauntList.map((obj: any) => obj.country).join(',');
    } else if (obj.RateTableTypeID === 43) {
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].FixedFTLMautCost = this.mauntList.map((obj: any) => obj.rate).join(',');
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].FixedFTLCountryID = this.mauntList
        .map((obj: any) => obj.country)
        .join(',');
    }
    this.appService.updateDataToDB();
  }

  onAdditonalSave() {
    let obj = this.appService.rateDateSource[this.appService.selectedItem];
    if (obj.RateTableTypeID === 42) {
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].AdditionalCost =
        this.chargesList.length === 0
          ? null
          : this.chargesList.map((obj: any) => obj.rate).join(',');
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].AdditionalCostItem =
        this.chargesList.length === 0
          ? null
          : this.chargesList.map((obj: any) => obj.charge).join(',');
    } else if (obj.RateTableTypeID === 43) {
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].FixedFTLAdditionalCost =
        this.chargesList.length === 0
          ? null
          : this.chargesList.map((obj: any) => obj.rate).join(',');
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].FixedFTLAdditionalCostItem =
        this.chargesList.length === 0
          ? null
          : this.chargesList.map((obj: any) => obj.charge).join(',');
    }
    this.appService.updateDataToDB();
  }

  getCountryList(evt: any) {
    // this.appService.isLoading = true;
    // this.httpService.getCountryList()
    //   .subscribe((res: any) => {
    //     this.appService.isLoading = false;
    //     if (res) {
    // console.trace();
    // this.mautSubscription.unsubscribe();
    this.countryListArr = this.appService.countryListArr
      .filter((i: any) => i.ISMaut)
      .sort((a: any, b: any) =>
        a.CountryName.toLowerCase() > b.CountryName.toLowerCase() ? 1 : -1
      );
    this.mauntList = [];

    const convertedData = evt.map((item: any) => {
      const countryObj = this.countryListArr.find(
        (country: any) => country.CountryName === item.country
      );
      const countryId = countryObj ? countryObj.CountryID : null;
      return {
        country: countryId,
        rate: parseFloat(item.rate),
      };
    });
    this.mauntList = [...convertedData];
    // this.mauntList = [...this.mauntList,...convertedData];
    this.changeDetect = 'testing';
    // }
    // })
  }

  checkOnCountryList(e: any, i: any) {
    this.appService.onRAvalueChanged = true;
    this.mauntList.find((obj: any) => obj.country == i.country).country =
      Number(e.value);
    this.onMautSave();
  }

  onAdditionVal(e: any, i: number, key: string) {
    this.appService.onRAvalueChanged = true;
    // if(key === "charge"){
    //   this.chargesList[i][key] = this.appService.escapeSingleQuotes(e.value);
    // }
    // else{
    if (key === 'rate') {
      this.chargesList[i][key] = Number(e.value);
    } else {
      this.chargesList[i][key] = e.value;
    }

    // }
    this.chargesList = [...this.chargesList];
    this.onAdditonalSave();
  }

  onMautVal(e: any, i: number, key: string) {
    this.appService.onRAvalueChanged = true;
    this.mauntList[i][key] = Number(e.value);
    this.mauntList = [...this.mauntList];
    this.onMautSave();
  }

  ngOnDestroy() {
    // Unsubscribe from subscriptions
    if (this.chargeSubscription) {
      this.chargeSubscription.unsubscribe();
    }
    if (this.mautSubscription) {
      this.mautSubscription.unsubscribe();
    }
  }
}
